export const getPricingBlockLabel = ({
  isUserLoggedIn,
  isUserSubscribed,
}: {
  isUserLoggedIn?: boolean;
  isUserSubscribed?: boolean;
}) => {
  if (isUserLoggedIn) {
    return isUserSubscribed ? 'Dashboard' : 'Upgrade';
  }

  return 'Select';
};
